import config from '@/configs/app'
import axios, { corsProxy } from '@/plugins/axios'

const PROXY = 'http://localhost:3000'
const DEVELOPER_TOKEN = config.ads.developerToken
const LOGIN_CUSTOMER_ID = config.ads.loginCustomerId

class AdsRequest {
  constructor (token, customerId) {
    this.accessToken = token.access_token || token
    this.customerId = customerId.replace('customers/', '')
    this.init()
  }

  init () {
    const baseURL = 'https://googleads.googleapis.com'
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
      'developer-token': DEVELOPER_TOKEN,
      'login-customer-id': LOGIN_CUSTOMER_ID
    }

    this.request = axios.create({ baseURL, headers })
    corsProxy(this.request, PROXY)
  }

  query (query) {
    const url = `v2/customers/${this.customerId}/googleAds:search`
    return this.request
      .post(url, { query })
      .then(res => res.data)
  }

  post (method, params) {
    const url = `v2/customers/${this.customerId}/${method}`
    return this.request
      .post(url, params)
      .then(res => res.data)
  }
}

export default AdsRequest
